import {
  GETBANK,
  DELETEBANK,
  UPDATEBANK,
} from "../actions/types";

const initialState = {};

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {
  switch (action.type) {
    case GETBANK:
      return {
        ...state,
        bankList: action.payload.data,
      };
    case UPDATEBANK:
      return {
        ...state,
        bankUpdateStatus: action.payload.success,
      };

    case DELETEBANK:
      return {
        ...state,
        bankDeleteStatus: action.payload.success,
      };

    default:
      return state;
  }
}
